(function(w,d){"use strict";if(w.__lvBeautyPixels)return;w.__lvBeautyPixels=1;
if(/[?&](preview_theme_id|pb)=/.test(w.location.search)||w.Shopify&&w.Shopify.designMode)return;
var M1="1078532564782723",M2="1583038503477044",SCOPE="biz_pWxretBoRizmt3";
var P={"/products/luvano-peptide-lash-serum":["15444948418747",["67940030480571","67940030513339","67940030546107"]],
"/products/luvano-peel-reveal-brow-tint":["15444948484283",["67940030611643","67940030644411","67940030677179","67940030709947","67940030742715"]],
"/products/luvano-silk-peptide-egf-toner":["15444948517051",["67940030808251","67940030841019","67940030873787"]],
"/products/luvano-dual-ended-foundation-stick":["15444948549819",["67940030939323","67940030972091","67940031004859"]]};
var path=w.location.pathname.replace(/\/$/,""),f=P[path];if(!f)return;var pid=f[0],V={};f[1].forEach(function(x){V[x]=1});
if(!w.fbq){var q=w.fbq=function(){q.callMethod?q.callMethod.apply(q,arguments):q.queue.push(arguments)};w._fbq||(w._fbq=q);q.push=q;q.loaded=!0;q.version="2.0";q.queue=[];var s=d.createElement("script");s.async=!0;s.src="https://connect.facebook.net/en_US/fbevents.js";d.head.appendChild(s);w.fbq("init",M1);w.fbq("init",M2)}
function fb(id,name,p){try{w.fbq("trackSingle",id,name,p||{})}catch(_){}}
var cp={content_ids:[pid],content_type:"product"};fb(M2,"ViewContent",cp);
var n="whop",a;if(!w[n]){a=w[n]={q:[],t:+new Date,s:[],o:"https://t.whop.tw",track:function(){a.q.push([+new Date].concat([].slice.call(arguments)))},setScope:function(){a.s=[].slice.call(arguments).filter(function(x){return typeof x=="string"});a.q.push([+new Date,"setScope"].concat(a.s))},scope:function(){var c=[].slice.call(arguments);return{track:function(){a.q.push([+new Date].concat([].slice.call(arguments)).concat([{__scope:c}]))}}}};var b=d.createElement("script");b.async=1;b.src="https://t.whop.tw/s.js";var f0=d.getElementsByTagName("script")[0];f0.parentNode.insertBefore(b,f0)}
w[n].setScope(SCOPE);w[n].track("page");w[n].track("view_content");
function added(){fb(M1,"AddToCart");fb(M2,"AddToCart",cp);try{w[n].track("add_to_cart")}catch(_){}}
function counts(cart){if(!cart||!Array.isArray(cart.items))return null;var q={};cart.items.forEach(function(x){var id=String(x&&x.variant_id!=null?x.variant_id:x&&x.id!=null?x.id:"");if(V[id]){var n=Number(x.quantity);if(isFinite(n)&&n>0)q[id]=(q[id]||0)+n}});return q}
function increased(next,prev){return Object.keys(V).some(function(id){return(next[id]||0)>(prev[id]||0)})}
var of=w.fetch;if(typeof of!="function")return;
function readCart(){return Promise.resolve(of.call(w,"/cart.js")).then(function(res){return res&&res.ok&&res.clone?res.clone().json():null}).then(counts).catch(function(){return null})}
var baseline=null;
var serial=readCart().then(function(q){baseline=q});
w.fetch=function(input,init){
  var r=of.apply(this,arguments),kind="";
  try{
    var raw=typeof input==="string"?input:input&&input.url||"";
    var method=String(init&&init.method||input&&input.method||"GET").toUpperCase();
    var url=new URL(raw,w.location.href);
    if(method==="POST"&&url.origin===w.location.origin){
      var match=/^\/cart\/(add|update|change|clear)\.js$/.exec(url.pathname);
      if(match)kind=match[1]
    }
  }catch(_){}
  if(kind){
    var action=kind;
    // Clone as the response settles, before the caller can consume its body.
    var observed=Promise.resolve(r).then(function(res){
      if(!res||!res.ok)return null;
      if(action==="add")return{kind:action};
      if(!res.clone)return null;
      return res.clone().json().then(function(cart){return{kind:action,counts:counts(cart)}})
    }).catch(function(){return null});
    // Chain at dispatch, so a later response cannot overtake an earlier request.
    serial=serial.then(function(){return observed}).then(function(event){
      if(!event)return;
      var next=event.kind==="add"?readCart():Promise.resolve(event.counts);
      return next.then(function(q){
        if(!q)return;
        if(baseline&&(event.kind==="add"||event.kind==="update")&&increased(q,baseline))added();
        baseline=q
      })
    }).catch(function(){})
  }
  return r
}
})(window,document);
